<template>
  <v-touch class="colorset-view" @panmove="move" @panend="moveend"
    :swipe-options="{ direction: 'vertical', threshold: 10 }"
  >
    <ul class="">
      <transition-group name="fade">
      <li class="color-item" v-for="(item, index) in colorset.array" :key="`${name}-${index}`"
        :style="{background: itemCssColor(item),
          transform:
            'translate(' + itemCssLeft(index) + ',' + itemCssTop(index) + ') ' +
            'scale(' + itemCssWidth(index) + ',' + itemCssHeight(index) + ')',
          }">
      </li>
      </transition-group>
    </ul>
  </v-touch>
</template>

<style scoped>
  .colorset-view{
    height: 100%;
  }
  ul {
    margin: 0;
    padding: 0;
    position: relative;
    height: 100%;
    overflow: hidden;
  }
  li {
    margin: 0;
    padding: 0;
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 100%;
    top: 100%;
    border: 0px solid white;
    box-sizing: border-box;
    transform-origin: 0% 0%;
    transition:
      all 500ms 0.15s cubic-bezier(.41,.8,.67,1)
      ;
  }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import Colorset from '../models/Colorset'
import TileLayout from '../logic/TileLayout'

export default {
  name: 'ColorsetView',
  data () {
    return {
      verticalSwipeBase: 0 // using in methods.move
    }
  },
  props: {
    name: String,
    colorset: Colorset
  },
  computed: {
    layout () {
      const amounts = this.colorset.array.map(item => item.p)
      const w = this.$el ? this.$el.clientWidth : 1
      const h = this.$el ? this.$el.clientHeight : 1
      const tl = new TileLayout(amounts, 45, 70, w / h).layout
      return tl
    }
  },
  methods: {
    move (e, isEnd) {
      const SETP_AMOUNT = 20
      const y = e.deltaY
      const x = e.deltaX
      // decide direction
      const isVertival = Math.abs(y) > Math.abs(x)
      const amount = isVertival ? y : x
      const base = this.$data.verticalSwipeBase
      if (isVertival && Math.abs(base - amount) > SETP_AMOUNT) {
        const stepCount = ((amount - base) / SETP_AMOUNT) | 0
        this.$data.verticalSwipeBase += stepCount * SETP_AMOUNT
        this.$emit('color-change', -stepCount)
      }
    },
    moveend (e) {
      this.move(e, true)
      this.$data.verticalSwipeBase = 0
    },
    itemCssColor (colorItem) {
      const rgb = colorItem.c
      return '#' + rgb.map(v => Math.floor(v).toString(16).padStart(2, '0')).join('')
    },
    itemCssWidth (index) {
      return (this.layout[index].width) / 100 + 0.1
    },
    itemCssHeight (index) {
      return (this.layout[index].height) / 100 + 0.1
    },
    itemCssLeft (index) {
      const w = this.$el ? this.$el.clientWidth : 0
      return this.layout[index].left * w / 100 - w + 'px'
    },
    itemCssTop (index) {
      const h = this.$el ? this.$el.clientHeight : 0
      return this.layout[index].top * h / 100 - h + 'px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorsetView.vue